import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";
import type { RouterOutputs } from "@/trpc";
import type { WeekKey } from "@/features/time-entry/utils/week-utils";

export type PendingExpense =
  RouterOutputs["expense"]["getPendingExpensesForOrg"][number];

/**
 * Hook to fetch pending expenses for organization review.
 * Returns a flat array of expenses.
 */
export function usePendingExpenses(params: {
  organizationBusinessUnitId: string;
  weekKey?: WeekKey;
  facilityId?: string;
  providerId?: string;
}) {
  const trpc = useTRPC();

  const {
    data: expenses,
    isLoading,
    error,
    refetch,
  } = useQuery(
    trpc.expense.getPendingExpensesForOrg.queryOptions({
      organizationBusinessUnitId: params.organizationBusinessUnitId,
      weekKey: params.weekKey,
      facilityId: params.facilityId,
      providerId: params.providerId,
    }),
  );

  return {
    expenses: (expenses ?? []) as PendingExpense[],
    isLoading,
    error,
    refetch,
  };
}
